import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import "../componentsStyle/question.css"
import Questions from './controls/questions';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Socket } from 'socket.io-client';
import Offline from './controls/offline';


type currentSideBarMenuList = "home" | "notification" | "alarm" | "edit" | "book" | "question" | "restaurant" | "envelope" | "search" | "chart" | "attendance" | "출석 관리 보고";

interface questionProps extends RouteComponentProps {
    activateMenuList: (curret: currentSideBarMenuList) => void;
    user: any;
    socket: Socket;
}


const Question: React.FC<questionProps> = (props) => {
    const [selectMenu, setSelectMenu] = useState("offline");
    const [pageStartNumber, setPageStartNumber] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [alignment, setAlignment] = React.useState('All');
    const [alignment2, setAlignment2] = React.useState('All');

    const changeSelectedMenu = (e: any, type: string) => {
        switch (type) {
            case "chemistry": setSelectMenu("chemistry"); setPageStartNumber(1); setCurrentPage(1); setAlignment2('All'); break;
            case "organic": setSelectMenu("organic"); setPageStartNumber(1); setCurrentPage(1); setAlignment2('All'); break;
            case "physics": setSelectMenu("physics"); setPageStartNumber(1); setCurrentPage(1); setAlignment2('All'); break;
            case "biology": setSelectMenu("biology"); setPageStartNumber(1); setCurrentPage(1); setAlignment2('All'); break;
            case "offline": setSelectMenu("offline"); setPageStartNumber(1); setCurrentPage(1); setAlignment2('All'); break;

        }
    }

    const pageChevron = (direction: String) => {
        if (direction === "left") {
            if (pageStartNumber != 1) {
                const page = pageStartNumber - 1;
                setPageStartNumber(pageStartNumber - 5);
                setCurrentPage(page);
            }
        } else if (direction === "right") {
            const page = pageStartNumber + 5;
            setPageStartNumber(pageStartNumber + 5);
            setCurrentPage(page);
        }
    }

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ) => {

        setAlignment(newAlignment);
    };

    const handleChange2 = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment2: string,
    ) => {
        setAlignment2(newAlignment2);
    };


    useEffect(() => {
        props.activateMenuList("question");
    }, [])

    return (
        <div className="main">
            <div className="title">
                <img src="img/playlist.svg" alt="playlist" />질의응답
            </div>

            <div className="selectMenu">
                <div onClick={(e) => { changeSelectedMenu(e, "offline") }} className={`selectedMenu ${selectMenu === "offline" ? "active" : ""}`}>
                    오프라인 신청방
                </div>
                <div onClick={(e) => { changeSelectedMenu(e, "chemistry") }} className={`selectedMenu ${selectMenu === "chemistry" ? "active" : ""}`}>
                    국어 질의응답방
                </div>
                <div onClick={(e) => { changeSelectedMenu(e, "organic") }} className={`selectedMenu ${selectMenu === "organic" ? "active" : ""}`}>
                    수학 질의응답방
                </div>
                <div onClick={(e) => { changeSelectedMenu(e, "physics") }} className={`selectedMenu ${selectMenu === "physics" ? "active" : ""}`}>
                    영어 질의응답방
                </div>
                <div onClick={(e) => { changeSelectedMenu(e, "biology") }} className={`selectedMenu ${selectMenu === "biology" ? "active" : ""}`}>
                    탐구 질의응답방
                </div>
            </div>

            <div className="questionBodyDiv">
                <div>
                    {
                        selectMenu != "offline" &&
                        <>
                            <ToggleButtonGroup
                                sx={{ marginTop: "20px", backgroundColor: "white" }}
                                color="primary"
                                value={alignment}
                                exclusive
                                onChange={handleChange}
                            >
                                <ToggleButton value="All">All</ToggleButton>
                                <ToggleButton value="My">My</ToggleButton>
                                {(props.user?.value === "teacher" || props.user?.value === "staff") &&
                                    <ToggleButton value="Unanswered">미응답</ToggleButton>
                                }
                            </ToggleButtonGroup>

                            {(props.user?.value === "teacher" || props.user?.value === "staff") &&
                                <ToggleButtonGroup
                                    sx={{ marginTop: "20px", marginLeft: "10px", backgroundColor: "white" }}
                                    color="primary"
                                    value={alignment2}
                                    exclusive
                                    onChange={handleChange2}
                                >
                                    <ToggleButton value="All">All</ToggleButton>
                                    <ToggleButton value="MyAnswer">내응답글</ToggleButton>
                                </ToggleButtonGroup>
                            }

                            <div className="qnaBoard">
                                <Questions socket={props.socket} user={props.user} subject={selectMenu} page={currentPage} alignment={alignment} alignment2={alignment2}></Questions>
                            </div>
                        </>
                    }



                </div>
                {
                selectMenu === 'offline' &&
                <Offline user={props.user} />
                }
            </div>




            {
                selectMenu != 'offline' && 
                <div className="pageNumberDiv">
                <div className="pageNumber">
                    <img onClick={() => { pageChevron("left"); }} className="chevron" src="img/chevronLeft.svg" alt="chevronLeft" />
                    {
                        [...Array(5)].map((x, i) => {
                            return (
                                <div key={Math.random()} onClick={() => { setCurrentPage(pageStartNumber + i) }} className={`currentPage ${currentPage === pageStartNumber + i ? "active" : ""}`}>
                                    {pageStartNumber + i}
                                </div>
                            )
                        })
                    }
                    <img className="chevron" onClick={() => { pageChevron("right"); }} src="img/chevronRight.svg" alt="chevronLeft" />
                </div>
            </div>
            }


            {selectMenu != 'offline' &&
                <Link to="/dashboard/question/write">
                    <div className="qnaWrite">
                        <img src="./img/pencil.svg" alt="pencil" />
                        질의응답 작성
                    </div>
                </Link>
            }



        </div>
    )
}

export default Question;